import myVar from './reducers/variable'

export const reducer: any = {
    myVar
}